// навигация
$(document).ready(function () {
  const section = $(".section"),
    nav = $("nav");

  if (window.location.hash) scrollToEl(window.location.hash);

  $(window).on("scroll", function () {
    const scrollTop = $(this).scrollTop();

    section.each(function () {
      const sectionOffsetTop = $(this).offset().top,
        sectionOffsetBottom = sectionOffsetTop + $(this).outerHeight();

      scrollTop >= sectionOffsetTop &&
        scrollTop <= sectionOffsetBottom &&
        (nav.find("a").removeClass("active"),
        section.removeClass("active"),
        $(this).addClass("active"),
        nav.find('a[href="#' + $(this).attr("id") + '"]').addClass("active"));
    });
  });

  nav.find("a").on("click", function () {
    const href = $(this).attr("href");
    scrollToEl(href);
  });

  function scrollToEl(href) {
    if ($(href).length) {
      const headerHeight = document.querySelector("header").offsetHeight,
        scrollTop =
          "#contacts" === href && window.innerWidth >= 1440
            ? $(href).offset().top + 400 - headerHeight - 20
            : $(href).offset().top + 1 - headerHeight - 20;
      $("html, body").animate(
        {
          scrollTop,
        },
        500
      );
    } else {
      window.location = `/${href}`;
    }
  }
});
// навигация
